import { Duck } from '@atc/modular-redux';
import selectors from './selectors';
import defaultState from './defaultState';
import reducer from './reducer';
import creators from './creators';
import types from './types';
export default function dealsDuckCreator(_temp) {
  let {
    namespace = '',
    store = 'deals',
    storePath,
    initialState = {},
    ...rest
  } = _temp === void 0 ? {} : _temp;
  return new Duck({
    ...rest,
    namespace,
    store,
    storePath,
    consts: {},
    types,
    initialState: {
      ...defaultState,
      ...initialState
    },
    reducer,
    selectors,
    creators
  });
}